// src/v3/GridItem/index.tsx
import { cx } from "class-variance-authority";

// src/v3/GridItem/gridItemVariants.ts
import { cva } from "class-variance-authority";
var spanVar = cva("", {
  variants: {
    sm: {
      1: "ui-col-span-1",
      2: "ui-col-span-2",
      3: "ui-col-span-3",
      4: "ui-col-span-4",
      5: "ui-col-span-5",
      6: "ui-col-span-6",
      7: "ui-col-span-7",
      8: "ui-col-span-8",
      9: "ui-col-span-9",
      10: "ui-col-span-10"
    },
    md: {
      1: "md:ui-col-span-1",
      2: "md:ui-col-span-2",
      3: "md:ui-col-span-3",
      4: "md:ui-col-span-4",
      5: "md:ui-col-span-5",
      6: "md:ui-col-span-6",
      7: "md:ui-col-span-7",
      8: "md:ui-col-span-8",
      9: "md:ui-col-span-9",
      10: "md:ui-col-span-10",
      11: "md:ui-col-span-11",
      12: "md:ui-col-span-12",
      13: "md:ui-col-span-13",
      14: "md:ui-col-span-14",
      15: "md:ui-col-span-15",
      16: "md:ui-col-span-16",
      17: "md:ui-col-span-17",
      18: "md:ui-col-span-18",
      19: "md:ui-col-span-19",
      20: "md:ui-col-span-20",
      21: "md:ui-col-span-21",
      22: "md:ui-col-span-22",
      23: "md:ui-col-span-23",
      24: "md:ui-col-span-24"
    },
    lg: {
      1: "lg:ui-col-span-1",
      2: "lg:ui-col-span-2",
      3: "lg:ui-col-span-3",
      4: "lg:ui-col-span-4",
      5: "lg:ui-col-span-5",
      6: "lg:ui-col-span-6",
      7: "lg:ui-col-span-7",
      8: "lg:ui-col-span-8",
      9: "lg:ui-col-span-9",
      10: "lg:ui-col-span-10",
      11: "lg:ui-col-span-11",
      12: "lg:ui-col-span-12",
      13: "lg:ui-col-span-13",
      14: "lg:ui-col-span-14",
      15: "lg:ui-col-span-15",
      16: "lg:ui-col-span-16",
      17: "lg:ui-col-span-17",
      18: "lg:ui-col-span-18",
      19: "lg:ui-col-span-19",
      20: "lg:ui-col-span-20",
      21: "lg:ui-col-span-21",
      22: "lg:ui-col-span-22",
      23: "lg:ui-col-span-23",
      24: "lg:ui-col-span-24"
    },
    xl: {
      1: "xl:ui-col-span-1",
      2: "xl:ui-col-span-2",
      3: "xl:ui-col-span-3",
      4: "xl:ui-col-span-4",
      5: "xl:ui-col-span-5",
      6: "xl:ui-col-span-6",
      7: "xl:ui-col-span-7",
      8: "xl:ui-col-span-8",
      9: "xl:ui-col-span-9",
      10: "xl:ui-col-span-10",
      11: "xl:ui-col-span-11",
      12: "xl:ui-col-span-12",
      13: "xl:ui-col-span-13",
      14: "xl:ui-col-span-14",
      15: "xl:ui-col-span-15",
      16: "xl:ui-col-span-16",
      17: "xl:ui-col-span-17",
      18: "xl:ui-col-span-18",
      19: "xl:ui-col-span-19",
      20: "xl:ui-col-span-20",
      21: "xl:ui-col-span-21",
      22: "xl:ui-col-span-22",
      23: "xl:ui-col-span-23",
      24: "xl:ui-col-span-24"
    },
    xxl: {
      1: "xxl:ui-col-span-1",
      2: "xxl:ui-col-span-2",
      3: "xxl:ui-col-span-3",
      4: "xxl:ui-col-span-4",
      5: "xxl:ui-col-span-5",
      6: "xxl:ui-col-span-6",
      7: "xxl:ui-col-span-7",
      8: "xxl:ui-col-span-8",
      9: "xxl:ui-col-span-9",
      10: "xxl:ui-col-span-10",
      11: "xxl:ui-col-span-11",
      12: "xxl:ui-col-span-12",
      13: "xxl:ui-col-span-13",
      14: "xxl:ui-col-span-14",
      15: "xxl:ui-col-span-15",
      16: "xxl:ui-col-span-16",
      17: "xxl:ui-col-span-17",
      18: "xxl:ui-col-span-18",
      19: "xxl:ui-col-span-19",
      20: "xxl:ui-col-span-20",
      21: "xxl:ui-col-span-21",
      22: "xxl:ui-col-span-22",
      23: "xxl:ui-col-span-23",
      24: "xxl:ui-col-span-24"
    }
  }
});
var colStartVar = cva("", {
  variants: {
    sm: {
      full: "ui-col-start-full",
      main: "ui-col-start-main",
      1: "ui-col-start-1",
      2: "ui-col-start-2",
      3: "ui-col-start-3",
      4: "ui-col-start-4",
      5: "ui-col-start-5",
      6: "ui-col-start-6",
      7: "ui-col-start-7",
      8: "ui-col-start-8",
      9: "ui-col-start-9"
    },
    md: {
      full: "md:ui-col-start-full",
      main: "md:ui-col-start-main",
      1: "md:ui-col-start-1",
      2: "md:ui-col-start-2",
      3: "md:ui-col-start-3",
      4: "md:ui-col-start-4",
      5: "md:ui-col-start-5",
      6: "md:ui-col-start-6",
      7: "md:ui-col-start-7",
      8: "md:ui-col-start-8",
      9: "md:ui-col-start-9",
      10: "md:ui-col-start-10",
      11: "md:ui-col-start-11",
      12: "md:ui-col-start-12",
      13: "md:ui-col-start-13",
      14: "md:ui-col-start-14",
      15: "md:ui-col-start-15",
      16: "md:ui-col-start-16",
      17: "md:ui-col-start-17",
      18: "md:ui-col-start-18",
      19: "md:ui-col-start-19",
      20: "md:ui-col-start-20",
      21: "md:ui-col-start-21",
      22: "md:ui-col-start-22",
      23: "md:ui-col-start-23"
    },
    lg: {
      full: "lg:ui-col-start-full",
      main: "lg:ui-col-start-main",
      1: "lg:ui-col-start-1",
      2: "lg:ui-col-start-2",
      3: "lg:ui-col-start-3",
      4: "lg:ui-col-start-4",
      5: "lg:ui-col-start-5",
      6: "lg:ui-col-start-6",
      7: "lg:ui-col-start-7",
      8: "lg:ui-col-start-8",
      9: "lg:ui-col-start-9",
      10: "lg:ui-col-start-10",
      11: "lg:ui-col-start-11",
      12: "lg:ui-col-start-12",
      13: "lg:ui-col-start-13",
      14: "lg:ui-col-start-14",
      15: "lg:ui-col-start-15",
      16: "lg:ui-col-start-16",
      17: "lg:ui-col-start-17",
      18: "lg:ui-col-start-18",
      19: "lg:ui-col-start-19",
      20: "lg:ui-col-start-20",
      21: "lg:ui-col-start-21",
      22: "lg:ui-col-start-22",
      23: "lg:ui-col-start-23"
    },
    xl: {
      full: "xl:ui-col-start-full",
      main: "xl:ui-col-start-main",
      1: "xl:ui-col-start-1",
      2: "xl:ui-col-start-2",
      3: "xl:ui-col-start-3",
      4: "xl:ui-col-start-4",
      5: "xl:ui-col-start-5",
      6: "xl:ui-col-start-6",
      7: "xl:ui-col-start-7",
      8: "xl:ui-col-start-8",
      9: "xl:ui-col-start-9",
      10: "xl:ui-col-start-10",
      11: "xl:ui-col-start-11",
      12: "xl:ui-col-start-12",
      13: "xl:ui-col-start-13",
      14: "xl:ui-col-start-14",
      15: "xl:ui-col-start-15",
      16: "xl:ui-col-start-16",
      17: "xl:ui-col-start-17",
      18: "xl:ui-col-start-18",
      19: "xl:ui-col-start-19",
      20: "xl:ui-col-start-20",
      21: "xl:ui-col-start-21",
      22: "xl:ui-col-start-22",
      23: "xl:ui-col-start-23"
    },
    xxl: {
      full: "xxl:ui-col-start-full",
      main: "xxl:ui-col-start-main",
      1: "xxl:ui-col-start-1",
      2: "xxl:ui-col-start-2",
      3: "xxl:ui-col-start-3",
      4: "xxl:ui-col-start-4",
      5: "xxl:ui-col-start-5",
      6: "xxl:ui-col-start-6",
      7: "xxl:ui-col-start-7",
      8: "xxl:ui-col-start-8",
      9: "xxl:ui-col-start-9",
      10: "xxl:ui-col-start-10",
      11: "xxl:ui-col-start-11",
      12: "xxl:ui-col-start-12",
      13: "xxl:ui-col-start-13",
      14: "xxl:ui-col-start-14",
      15: "xxl:ui-col-start-15",
      16: "xxl:ui-col-start-16",
      17: "xxl:ui-col-start-17",
      18: "xxl:ui-col-start-18",
      19: "xxl:ui-col-start-19",
      20: "xxl:ui-col-start-20",
      21: "xxl:ui-col-start-21",
      22: "xxl:ui-col-start-22",
      23: "xxl:ui-col-start-23"
    }
  }
});
var colEndVar = cva("", {
  variants: {
    sm: {
      full: "ui-col-end-full",
      main: "ui-col-end-main",
      1: "ui-col-end-1",
      2: "ui-col-end-2",
      3: "ui-col-end-3",
      4: "ui-col-end-4",
      5: "ui-col-end-5",
      6: "ui-col-end-6",
      7: "ui-col-end-7",
      8: "ui-col-end-8",
      9: "ui-col-end-9",
      10: "ui-col-end-10"
    },
    md: {
      full: "md:ui-col-end-full",
      main: "md:ui-col-end-main",
      1: "md:ui-col-end-1",
      2: "md:ui-col-end-2",
      3: "md:ui-col-end-3",
      4: "md:ui-col-end-4",
      5: "md:ui-col-end-5",
      6: "md:ui-col-end-6",
      7: "md:ui-col-end-7",
      8: "md:ui-col-end-8",
      9: "md:ui-col-end-9",
      10: "md:ui-col-end-10",
      11: "md:ui-col-end-11",
      12: "md:ui-col-end-12",
      13: "md:ui-col-end-13",
      14: "md:ui-col-end-14",
      15: "md:ui-col-end-15",
      16: "md:ui-col-end-16",
      17: "md:ui-col-end-17",
      18: "md:ui-col-end-18",
      19: "md:ui-col-end-19",
      20: "md:ui-col-end-20",
      21: "md:ui-col-end-21",
      22: "md:ui-col-end-22",
      23: "md:ui-col-end-23",
      24: "md:ui-col-end-24"
    },
    lg: {
      full: "lg:ui-col-end-full",
      main: "lg:ui-col-end-main",
      1: "lg:ui-col-end-1",
      2: "lg:ui-col-end-2",
      3: "lg:ui-col-end-3",
      4: "lg:ui-col-end-4",
      5: "lg:ui-col-end-5",
      6: "lg:ui-col-end-6",
      7: "lg:ui-col-end-7",
      8: "lg:ui-col-end-8",
      9: "lg:ui-col-end-9",
      10: "lg:ui-col-end-10",
      11: "lg:ui-col-end-11",
      12: "lg:ui-col-end-12",
      13: "lg:ui-col-end-13",
      14: "lg:ui-col-end-14",
      15: "lg:ui-col-end-15",
      16: "lg:ui-col-end-16",
      17: "lg:ui-col-end-17",
      18: "lg:ui-col-end-18",
      19: "lg:ui-col-end-19",
      20: "lg:ui-col-end-20",
      21: "lg:ui-col-end-21",
      22: "lg:ui-col-end-22",
      23: "lg:ui-col-end-23",
      24: "lg:ui-col-end-24"
    },
    xl: {
      full: "xl:ui-col-end-full",
      main: "xl:ui-col-end-main",
      1: "xl:ui-col-end-1",
      2: "xl:ui-col-end-2",
      3: "xl:ui-col-end-3",
      4: "xl:ui-col-end-4",
      5: "xl:ui-col-end-5",
      6: "xl:ui-col-end-6",
      7: "xl:ui-col-end-7",
      8: "xl:ui-col-end-8",
      9: "xl:ui-col-end-9",
      10: "xl:ui-col-end-10",
      11: "xl:ui-col-end-11",
      12: "xl:ui-col-end-12",
      13: "xl:ui-col-end-13",
      14: "xl:ui-col-end-14",
      15: "xl:ui-col-end-15",
      16: "xl:ui-col-end-16",
      17: "xl:ui-col-end-17",
      18: "xl:ui-col-end-18",
      19: "xl:ui-col-end-19",
      20: "xl:ui-col-end-20",
      21: "xl:ui-col-end-21",
      22: "xl:ui-col-end-22",
      23: "xl:ui-col-end-23",
      24: "xl:ui-col-end-24"
    },
    xxl: {
      full: "xxl:ui-col-end-full",
      main: "xxl:ui-col-end-main",
      1: "xxl:ui-col-end-1",
      2: "xxl:ui-col-end-2",
      3: "xxl:ui-col-end-3",
      4: "xxl:ui-col-end-4",
      5: "xxl:ui-col-end-5",
      6: "xxl:ui-col-end-6",
      7: "xxl:ui-col-end-7",
      8: "xxl:ui-col-end-8",
      9: "xxl:ui-col-end-9",
      10: "xxl:ui-col-end-10",
      11: "xxl:ui-col-end-11",
      12: "xxl:ui-col-end-12",
      13: "xxl:ui-col-end-13",
      14: "xxl:ui-col-end-14",
      15: "xxl:ui-col-end-15",
      16: "xxl:ui-col-end-16",
      17: "xxl:ui-col-end-17",
      18: "xxl:ui-col-end-18",
      19: "xxl:ui-col-end-19",
      20: "xxl:ui-col-end-20",
      21: "xxl:ui-col-end-21",
      22: "xxl:ui-col-end-22",
      23: "xxl:ui-col-end-23",
      24: "xxl:ui-col-end-24"
    }
  }
});
var rowStartVar = cva("", {
  variants: {
    sm: {
      1: "ui-row-start-1",
      2: "ui-row-start-2",
      3: "ui-row-start-3",
      4: "ui-row-start-4",
      5: "ui-row-start-5",
      6: "ui-row-start-6",
      7: "ui-row-start-7",
      8: "ui-row-start-8",
      9: "ui-row-start-9",
      10: "ui-row-start-10",
      11: "ui-row-start-11",
      12: "ui-row-start-12"
    },
    md: {
      1: "md:ui-row-start-1",
      2: "md:ui-row-start-2",
      3: "md:ui-row-start-3",
      4: "md:ui-row-start-4",
      5: "md:ui-row-start-5",
      6: "md:ui-row-start-6",
      7: "md:ui-row-start-7",
      8: "md:ui-row-start-8",
      9: "md:ui-row-start-9",
      10: "md:ui-row-start-10",
      11: "md:ui-row-start-11",
      12: "md:ui-row-start-12"
    },
    lg: {
      1: "lg:ui-row-start-1",
      2: "lg:ui-row-start-2",
      3: "lg:ui-row-start-3",
      4: "lg:ui-row-start-4",
      5: "lg:ui-row-start-5",
      6: "lg:ui-row-start-6",
      7: "lg:ui-row-start-7",
      8: "lg:ui-row-start-8",
      9: "lg:ui-row-start-9",
      10: "lg:ui-row-start-10",
      11: "lg:ui-row-start-11",
      12: "lg:ui-row-start-12"
    },
    xl: {
      1: "xl:ui-row-start-1",
      2: "xl:ui-row-start-2",
      3: "xl:ui-row-start-3",
      4: "xl:ui-row-start-4",
      5: "xl:ui-row-start-5",
      6: "xl:ui-row-start-6",
      7: "xl:ui-row-start-7",
      8: "xl:ui-row-start-8",
      9: "xl:ui-row-start-9",
      10: "xl:ui-row-start-10",
      11: "xl:ui-row-start-11",
      12: "xl:ui-row-start-12"
    },
    xxl: {
      1: "xxl:ui-row-start-1",
      2: "xxl:ui-row-start-2",
      3: "xxl:ui-row-start-3",
      4: "xxl:ui-row-start-4",
      5: "xxl:ui-row-start-5",
      6: "xxl:ui-row-start-6",
      7: "xxl:ui-row-start-7",
      8: "xxl:ui-row-start-8",
      9: "xxl:ui-row-start-9",
      10: "xxl:ui-row-start-10",
      11: "xxl:ui-row-start-11",
      12: "xxl:ui-row-start-12"
    }
  }
});
var rowEndVar = cva("", {
  variants: {
    sm: {
      2: "ui-row-end-2",
      3: "ui-row-end-3",
      4: "ui-row-end-4",
      5: "ui-row-end-5",
      6: "ui-row-end-6",
      7: "ui-row-end-7",
      8: "ui-row-end-8",
      9: "ui-row-end-9",
      10: "ui-row-end-10",
      11: "ui-row-end-11",
      12: "ui-row-end-12"
    },
    md: {
      2: "md:ui-row-end-2",
      3: "md:ui-row-end-3",
      4: "md:ui-row-end-4",
      5: "md:ui-row-end-5",
      6: "md:ui-row-end-6",
      7: "md:ui-row-end-7",
      8: "md:ui-row-end-8",
      9: "md:ui-row-end-9",
      10: "md:ui-row-end-10",
      11: "md:ui-row-end-11",
      12: "md:ui-row-end-12"
    },
    lg: {
      2: "lg:ui-row-end-2",
      3: "lg:ui-row-end-3",
      4: "lg:ui-row-end-4",
      5: "lg:ui-row-end-5",
      6: "lg:ui-row-end-6",
      7: "lg:ui-row-end-7",
      8: "lg:ui-row-end-8",
      9: "lg:ui-row-end-9",
      10: "lg:ui-row-end-10",
      11: "lg:ui-row-end-11",
      12: "lg:ui-row-end-12"
    },
    xl: {
      2: "xl:ui-row-end-2",
      3: "xl:ui-row-end-3",
      4: "xl:ui-row-end-4",
      5: "xl:ui-row-end-5",
      6: "xl:ui-row-end-6",
      7: "xl:ui-row-end-7",
      8: "xl:ui-row-end-8",
      9: "xl:ui-row-end-9",
      10: "xl:ui-row-end-10",
      11: "xl:ui-row-end-11",
      12: "xl:ui-row-end-12"
    },
    xxl: {
      2: "xxl:ui-row-end-2",
      3: "xxl:ui-row-end-3",
      4: "xxl:ui-row-end-4",
      5: "xxl:ui-row-end-5",
      6: "xxl:ui-row-end-6",
      7: "xxl:ui-row-end-7",
      8: "xxl:ui-row-end-8",
      9: "xxl:ui-row-end-9",
      10: "xxl:ui-row-end-10",
      11: "xxl:ui-row-end-11",
      12: "xxl:ui-row-end-12"
    }
  }
});

// src/v3/GridItem/index.tsx
import { jsx } from "react/jsx-runtime";
function GridItem({
  children,
  className,
  colEnd,
  colStart,
  Element = "div",
  rowEnd,
  rowStart,
  span,
  ...props
}) {
  const {
    sm: smallSpan,
    md: mediumSpan,
    lg: largeSpan,
    xl: xlSpan,
    xxl: xxlSpan
  } = span || {};
  const {
    sm: smallStart,
    md: mediumStart,
    lg: largeStart,
    xl: xlStart,
    xxl: xxlStart
  } = colStart || {};
  const {
    sm: smallEnd,
    md: mediumEnd,
    lg: largeEnd,
    xl: xlEnd,
    xxl: xxlEnd
  } = colEnd || {};
  const {
    sm: smallRowStart,
    md: mediumRowStart,
    lg: largeRowStart,
    xl: xlRowStart,
    xxl: xxlRowStart
  } = rowStart || {};
  const {
    sm: smallRowEnd,
    md: mediumRowEnd,
    lg: largeRowEnd,
    xl: xlRowEnd,
    xxl: xxlRowEnd
  } = rowEnd || {};
  return /* @__PURE__ */ jsx(Element, {
    className: cx(
      spanVar({
        sm: smallSpan,
        md: mediumSpan,
        lg: largeSpan,
        xl: xlSpan,
        xxl: xxlSpan
      }),
      colStartVar({
        sm: smallStart,
        md: mediumStart,
        lg: largeStart,
        xl: xlStart,
        xxl: xxlStart
      }),
      colEndVar({
        sm: smallEnd,
        md: mediumEnd,
        lg: largeEnd,
        xl: xlEnd,
        xxl: xxlEnd
      }),
      rowStartVar({
        sm: smallRowStart,
        md: mediumRowStart,
        lg: largeRowStart,
        xl: xlRowStart,
        xxl: xxlRowStart
      }),
      rowEndVar({
        sm: smallRowEnd,
        md: mediumRowEnd,
        lg: largeRowEnd,
        xl: xlRowEnd,
        xxl: xxlRowEnd
      }),
      className
    ),
    "data-cy": "gridItem_div",
    ...props,
    children
  });
}
GridItem.displayName = "GridItem";
export {
  GridItem
};
//# sourceMappingURL=index.mjs.map